import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, Input, OnChanges, ChangeDetectorRef } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { DynamicDialogRef, DialogService, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { HelperService, HTTPService, DataService, CalculationService, ValidationService, DateService } from 'app/services';
import { datetimeFormat } from '../../../constants/date-time-format';
import * as moment from 'moment';

@Component({
  selector: 'app-delete-category-dialog',
  templateUrl: './delete-category-dialog.component.html',
  styleUrls: ['./delete-category-dialog.component.scss'],
})
export class DeleteCategoryDialogComponent implements OnInit {
  isLoading = false;
  isNewCategoriesEnabled: boolean = false;
  isDeleteLoading = false;
  isValid: boolean = true;
  selectedDay: any = {};
  selectedValue: any = {};
  categoryResults: any = [];
  categories: any = [];
  isOnlyDelete: boolean = false;
  categoryType: string = '';
  count: any = 0;
  type: boolean = true;
  selectedDelete = 'delete';
  subscription: Subscription;
  dialogType = 'category'; // category/salesGroup
  dialogTitle = 'Delete';
  isMidasRoyaltyReportsEnabled: boolean = false;
  // For dialogType == salesGroup
  salesCodeCount: number = 0;
  salesGroups: any[] = [];
  currentSalesGroup: any = {};
  updateSalesGroup: any = {};
  newSalesGroup: any = {};
  isSalesGroupCreationEnabled = false;
  loader = {
    isSalesGroupDeleting: false,
    isSalesGroupCreating: false,
  };
  errors = {
    salesGroup: {
      isValid: false,
      fields: {
        name: '',
        groupCode: '',
        m2GroupCode: '',
        m2GroupName: '',
      },
    },
  };

  deleteCategoryOption = [
    { id: 1, name: 'Delete this category', field: 'delete', text: 'All associated items with this category will be updated to clear their category and marked as unassigned (to category)' },
    { id: 2, name: 'Replace and Delete', field: 'replaceAndDelete', text: 'Select a new category to move the associated items to and then delete the category.' },
  ];

  constructor(
    private helperService: HelperService,
    private httpService: HTTPService,
    private dynamicDialogRef: DynamicDialogRef,
    private dataService: DataService,
    private dialogConfig: DynamicDialogConfig,
    private dateService: DateService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef,
    private validationService: ValidationService
  ) {}

  ngOnInit() {
    const { selectedCategory, categoryList, type, isOnlyDelete, count, newCategoryData, dialogType = 'category' } = this.dialogConfig.data;

    this.dialogType = dialogType;
    this.isMidasRoyaltyReportsEnabled = this.dataService.isMidasRoyaltyReportsEnable;

    if (this.dialogType === 'category') {
      this.dialogTitle += ' Category';

      this.categoryResults = categoryList;
      this.isOnlyDelete = isOnlyDelete;
      this.count = count;
      this.categoryType = type;
      this.setDataService(newCategoryData);

      if (selectedCategory) {
        this.selectedValue = selectedCategory;
      }

      if (this.categoryResults?.length) {
        this.removeSelectedCategory(this.categoryResults, this.selectedValue);
      }
    } else if (this.dialogType === 'salesGroup') {
      this.dialogTitle += ' Sales Group';
      this.salesCodeCount = this.dialogConfig.data.salesCodeCount;
      this.currentSalesGroup = this.dialogConfig.data.currentSalesGroup;
      this.onSalesGroupSearch('');
    }
  }

  setDataService(category: any) {
    this.subscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (['company-appdata-updated'].includes(data.key)) {
          this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
          if (this.isNewCategoriesEnabled) {
            this.selectedValue = category;
          }
        }
      }
    });
    this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
    if (this.isNewCategoriesEnabled) {
      this.selectedValue = category;
    }
  }

  removeSelectedCategory(categoryList, selectedCategory) {
    this.categoryResults.forEach((item, index) => {
      if (item._id === this.selectedValue._id) this.categoryResults.splice(index, 1);
    });
  }

  getCategoryList(category) {
    this.httpService
      .getAllCategories(category._id)
      .then((data) => {
        this.categoryResults = data;
        // this.categoryResults = [...categories];
      })
      .catch((err) => this.helperService.showToaster('error', err));
  }

  closeDialog() {
    this.dynamicDialogRef.close();
  }

  cancelDialog() {
    this.dynamicDialogRef.close({
      isSuccess: false,
    });
  }

  onSelect($event, type) {}

  onAutoCompleteSelect(event: any, type?: string) {
    if (type === 'tags') {
      this.selectedValue = event;
      this.isValid = event ? false : true;
    }
  }

  onClearSuggestion(type: string = '') {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  handleAppSettingChange(e) {
    this.selectedDelete = e;
    if (e === 'replaceAndDelete') {
      this.type = false;
    } else if (e === 'delete') {
      this.type = true;
    }
  }

  onSubmit(e) {
    const { selectedCategory, categoryList, type, catType, newTireModal } = this.dialogConfig.data;
    let deleteCategory = {};
    if (e === 'replaceAndDelete') {
      this.isLoading = true;
      deleteCategory = {
        replaceCategory: {
          categoryId: this.selectedValue._id,
          name: this.selectedValue.name,
        },
        category: {
          categoryId: selectedCategory._id,
          name: selectedCategory.name,
        },
      };
    } else if (e === 'delete' && !this.isNewCategoriesEnabled) {
      this.isDeleteLoading = true;
      deleteCategory = {
        category: {
          categoryId: selectedCategory._id || this.selectedValue._id,
          name: selectedCategory.name || selectedCategory.categoryName,
        },
        type: type,
      };
    }

    if (e === 'delete' && this.isNewCategoriesEnabled) {
      if (catType === 'category') {
        this.deleteCategory(deleteCategory, e);
      } else if (catType === 'subCategory') {
        this.deleteSubCategory();
      } else if (catType === 'subSubCategory') {
        this.deleteSubSubCategory();
      } else {
        // if (type === 'inspection_item_cat') {
        //   this.deleteCategory(deleteCategory, e);
        // } else 
        // if (type === 'service_cat' || type === 'inspection_item_cat') {
          this.isDeleteLoading = true;
          deleteCategory = {
            category: {
              categoryId: selectedCategory._id,
              name: selectedCategory.name || selectedCategory.categoryName,
            },
            type: type,
          };
          this.deleteTag(deleteCategory, e);
        // }
      }
    } else if (newTireModal && !this.isNewCategoriesEnabled) {
      this.deleteCategory(deleteCategory, e);
    } else {
      this.httpService.deleteCategory(deleteCategory).then(
        (res) => {
          this.dynamicDialogRef.close({
            isSuccess: true,
            data: deleteCategory,
            selectedName: e === 'replaceAndDelete' ? this.selectedValue.name : 'Unassigned',
          });
        },
        (err) => {
          this.isLoading = false;
          this.isDeleteLoading = false;
        }
      );
    }
  }

  deleteTag(deleteCategory: any, e: string) {    
    this.httpService.deleteTag(deleteCategory.category.categoryId).then(
      (res: any) => {
        this.dynamicDialogRef.close({
          isSuccess: true,
          data: deleteCategory,
          selectedName: e === 'replaceAndDelete' ? this.selectedValue.name : 'Unassigned',
        });
      },
      (err: any) => {
        this.isLoading = false;
        this.isDeleteLoading = false;
      }
    );
  }

  deleteCategory(deleteCategory, e) {
    this.httpService.deletingCategory((this.selectedValue.categoryId || this.selectedValue._id),  this.categoryType).then(
      (res) => {
        this.dynamicDialogRef.close({
          isSuccess: true,
          data: deleteCategory,
          selectedName: e === 'replaceAndDelete' ? this.selectedValue.name : 'Unassigned',
        });
      },
      (err) => {
        this.isLoading = false;
        this.isDeleteLoading = false;
      }
    );
  }

  deleteSubCategory() {
    this.httpService.deletingSubCategory(this.selectedValue.categoryId, this.selectedValue.subCategoryId, this.categoryType).then(
      (res) => {
        this.dynamicDialogRef.close({
          isSuccess: true,
        });
      },
      (err) => {
        this.isLoading = false;
        this.isDeleteLoading = false;
      }
    );
  }

  deleteSubSubCategory() {
    this.httpService.deletingSubSubCategory(this.selectedValue.categoryId, this.selectedValue.subCategoryId, this.selectedValue.subSubCategoryId, this.categoryType).then(
      (res) => {
        this.dynamicDialogRef.close({
          isSuccess: true,
        });
      },
      (err) => {
        this.isLoading = false;
        this.isDeleteLoading = false;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // For dialogType == salesGroup
  handleToggleSalesGroupCreate(isSalesGroupCreationEnabled: boolean = false) {
    this.isSalesGroupCreationEnabled = isSalesGroupCreationEnabled;
  }

  handleSalesGroupChange(key: string, value: any) {
    this.newSalesGroup[key] = value;
  }

  async handleSalesGroupCreate(close) {
    const payload = {
      type: 'sales_group',
      name: this.newSalesGroup.name,
      groupCode: this.newSalesGroup.groupCode,
      m2GroupName: this.newSalesGroup.m2GroupName,
      m2GroupCode: this.newSalesGroup.m2GroupCode,
    };
    this.errors.salesGroup.isValid = true;
    this.errors.salesGroup.fields = { name: '', groupCode: '', m2GroupName: '', m2GroupCode: '' };

    if (!payload.name) {
      this.errors.salesGroup.fields.name = 'Group name required';
      this.errors.salesGroup.isValid = false;
    }
    if (!payload.groupCode) {
      this.errors.salesGroup.fields.groupCode = 'Group code required';
      this.errors.salesGroup.isValid = false;
    }

    if (this.isMidasRoyaltyReportsEnabled) {
      if (!payload.m2GroupCode) {
        this.errors.salesGroup.fields.m2GroupCode = 'Group code required';
        this.errors.salesGroup.isValid = false;
      }

      if (!payload.m2GroupName) {
        this.errors.salesGroup.fields.m2GroupName = 'Group name required';
        this.errors.salesGroup.isValid = false;
      }
    }

    if (!this.errors.salesGroup.isValid) return;

    try {
      this.loader.isSalesGroupCreating = true;
      const tag = await this.httpService.createTag(payload);
      this.onSalesGroupSelect(tag);

      if (close) close();
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.isSalesGroupCreating = false;
    }
  }

  onSalesGroupSelect(salesGroup: any) {
    this.updateSalesGroup = {
      _id: salesGroup._id,
      name: salesGroup.name,
      code: salesGroup.groupCode,
    };
  }

  async onSalesGroupSearch(query: string = '') {
    try {
      const salesGroupList: any[] = (await this.httpService.getTags('sales_group', query)) as any[];
      this.salesGroups = salesGroupList?.filter((saleGroup: any) => {
        return saleGroup?._id !== this.currentSalesGroup?._id;
      }) || [];
    } catch (err) {
      this.helperService.showToaster('error', err);
    }
  }

  async deleteAndReplaceSalesCode() {
    this.loader.isSalesGroupDeleting = true;
    try {
      await this.httpService.deleteAndReplaceSalesGroup({
        oSalesGroup: this.currentSalesGroup,
        nSalesGroup: this.updateSalesGroup,
      });
      this.helperService.showToaster('success', 'Successfully deleted and replaced');
      this.dynamicDialogRef.close({
        isSuccess: true,
        data: {
          replacedSalesGroup: this.updateSalesGroup
        }
      });
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.loader.isSalesGroupDeleting = false;
    }
  }
}
